import { ICellRendererParams } from '@ag-grid-community/core';
import { Grid, Typography } from '@mui/material';
import { makeStyles } from '@mui/styles';
import { AssetTypes } from '@tassat/common-definitions';
import { AssetTicker, WalletRecordMapped } from '@tassat/fred-extended-definitions';
import { formatAsAsset } from '@tassat/utility';
import React from 'react';

import { useAppSelector } from 'Reducers/store/hooks';
import { getAssetsMap } from 'Selectors/assets';

interface FormatAvailBalanceProps extends ICellRendererParams {
    data: WalletRecordMapped;
}

const muiStyles = makeStyles({ cell: { fontSize: '13px' }});

export const FormatAvailBalance = (props: FormatAvailBalanceProps) => {
    const { data } = props;
    const assetsMap = useAppSelector(getAssetsMap);
    if (!data) return <></>;

    const classes = muiStyles();
    const stats = data.walletStats ?? [];

    // Exclude FTIXX entries for Goldman.
    const currencyStats = stats.filter(stat => assetsMap[stat.AssetId]?.Type === AssetTypes.CURRENCY &&
        assetsMap[stat.AssetId]?.Ticker !== AssetTicker.FTIXX);
    const securityStats = stats.filter(stat => assetsMap[stat.AssetId]?.Type === AssetTypes.ASSET &&
        assetsMap[stat.AssetId]?.Ticker !== AssetTicker.FTIXX);

    return (
        <Grid
            container
            direction='column'
        >
            {currencyStats.map((stat) => (
                <Typography
                    className={classes.cell}
                    data-testid='available-balance-1'
                    key={stat.AssetId}
                >
                    {formatAsAsset(stat.AvailablePosition, assetsMap[stat.AssetId], 'curcode')}
                </Typography>
            ))}
            {securityStats.map((stat) => (
                <Typography
                    className={classes.cell}
                    data-testid='available-balance-2'
                    key={stat.AssetId}
                >
                    {formatAsAsset(stat.AvailablePosition, assetsMap[stat.AssetId], 'ticker', undefined, true)}
                </Typography>
            ))}
        </Grid>
    );
};

export default FormatAvailBalance;